// src/modules/ida/components/FollowUpSuggestionChips.tsx
//
// Clickable follow-up questions shown above the composer after an IDA answer.
// Styling comes only from Joy palette props and theme tokens, so both brand
// schemes render it through the shared theme engine.

import React from "react";
import { Box, Button } from "@mui/joy";

interface FollowUpSuggestionChipsProps {
  suggestions: string[];
  onSelect: (suggestion: string) => void;
  disabled?: boolean;
}

export const FollowUpSuggestionChips: React.FC<
  FollowUpSuggestionChipsProps
> = ({ suggestions, onSelect, disabled = false }) => {
  if (suggestions.length === 0) {
    return null;
  }

  return (
    <Box
      role="group"
      aria-label="Suggested follow-up questions"
      data-testid="follow-up-suggestions"
      sx={{ display: "flex", flexWrap: "wrap", gap: 1 }}
    >
      {suggestions.map((suggestion) => (
        <Button
          key={suggestion}
          variant="outlined"
          color="neutral"
          size="sm"
          disabled={disabled}
          onClick={() => onSelect(suggestion)}
          sx={{
            borderRadius: "16px",
            fontWeight: "normal",
            textAlign: "left",
            whiteSpace: "normal",
            height: "auto",
            py: 0.5,
          }}
        >
          {suggestion}
        </Button>
      ))}
    </Box>
  );
};

export default FollowUpSuggestionChips;
